<template>
  
    
  <div class="m-1 p-1">
    <span style="font-weight: bold">掲載中の大会</span>
    <div class="my-1">
      <table class="table">
      <tbody>
        <!-- <tr style="border-top:1px solid lightgray; border-bottom:1px solid lightgray">
          <td class="text-left align-middle m-1 p-1" width="80px"><img src="/taikai/yashio-eight-arena.png" class="rounded-3" height="100"/></td>
          <td class="text-left"><b>令和６年度 夏季大会</b><br>2024年5月17日(土)<br>団体戦</td>
          <td class="text-center align-middle bg-body-secondary"><router-link to="/match"><font-awesome-icon :icon="['fas', 'angle-right']" /></router-link></td>
        </tr> -->
        <tr style="border-top:1px solid lightgray; border-bottom:1px solid lightgray" @click="() => $router.push({ name: 'matchCard'})">
          <td class="text-left align-middle m-1 p-1" width="100px"><img src="/taikai/enecle_sports_arena.jpg" class="rounded-3" height="100"/></td>
          <td class="text-left"><b>令和８年度 夏季大会</b><br>2026年8月1日(土)<br>ダブルス</td>
          <td class="text-center align-middle bg-body-secondary"><router-link to="/match"><font-awesome-icon :icon="['fas', 'angle-right']" /></router-link></td>
        </tr>
      </tbody>
      </table>
    </div>
  </div>

  <!-- <AffiliateWidgetComponent /> -->

  <div class="m-0 mb-4 p-0">
    <div>      
      <div class="m-1 p-1"><span style="font-weight: bold">お知らせ</span></div>
      <template v-for="note in notes">
        <div class="shadow p-1 m-1 mx-2 rounded" style="background-color: #fff3cd;">
          <div class="mt-0 mx-1" style="text-align: right;font-size: 10pt;font-weight: 600;color: tan">{{ note.timestamp }}</div>
          <span style="font-size:11pt;" v-html="note.message"></span>
        </div>
      </template>      
    </div>
  </div>

  <!-- <footer class="container-fluid mt-5">
  <div class="row" style="background-color: black">
    <ul class="nav justify-content-center py-5">
  		<li class="nav-item">
    		<a class="nav-link" href="#">Active</a>
  		</li>
  		<li class="nav-item">
   			 <a class="nav-link" href="#">Link</a>
 		 </li>
 		 <li class="nav-item">
  			  <a class="nav-link" href="#">Link</a>
  		</li>		 
	</ul>
  </div>
</footer> -->

  <EditInfoFormComponent />
  <!-- <FooterComponent @reloadInfo="reloadInfo"></FooterComponent> -->



  <!-- fab -->
  <div class="fab-container" v-if="user && user.email">
        <div class="button iconbutton" data-bs-toggle="modal" data-bs-target="#editInfoModal" >
            <font-awesome-icon :icon="['fas', 'pen']" id="filter-icon" />
        </div>
  </div>
</template>

<script setup>
import FooterComponent from '@/components/FooterComponent.vue'
import AffiliateWidgetComponent from '@/components/AffiliateWidgetComponent.vue'
import EditInfoFormComponent from '@/components/EditInfoFormComponent.vue'
import { ref, onMounted } from 'vue';
import { ref as fbRef, getDatabase, child, get } from "firebase/database"
import { getAuth } from "firebase/auth";
const auth = getAuth();
const user = auth.currentUser;
const db = getDatabase();
const dbRef = fbRef(db);
const notes = ref([])

onMounted(() => {
  fetchNotes()
})

const reloadInfo = async () => {
  await fetchNotes()
}

const fetchNotes = async () => {
  get(child(dbRef, '/2026-summer/info'))
    .then((snapshot) => {
      if (snapshot.exists()) {
        notes.value = snapshot.val()
        notes.value = Object.fromEntries(Object.entries(notes.value)
        .filter(([key, value]) => (value.visible != '' && value.visible == '1'))
        .sort(function (a, b) { return -1
        // if (parseInt(b[0]) < parseInt(a[0])) { return 1 }
        // if (parseInt(a[0]) > parseInt(b[0])) { return -1 }
          if (a[1].timestamp < b[1].timestamp) { return -1 }
          if (a[1].timestamp > b[1].timestamp) { return 1 }

          return 0
        })
        )
      } else {
        console.log('No notes data available')
      }
    })
    .catch((error) => {
      console.error(error)
    })
}
</script>

<style scoped>
.fab-container {
  position: fixed;
  bottom: 70px;
  right: 20px;
  /* left: 50%; */
  cursor: pointer;
  z-index: 998;
}

.iconbutton {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background: #3D8BFD;
    box-shadow: 5px 5px 5px #aaaaaa;
}

#filter-icon {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 20px;
    color: white;
    padding: 15px;
}

.button {
    width: 50px;
    height: 50px;
    background: #0d6efd;
}
</style>
